import { Radio, RadioGroup, FormControlLabel, Typography } from "@mui/material";
import LoadingSkteleton from "../../../../../../load/loadingSkeleton";

// const AUTORIZACAO = [
//     // Farmácia
//     { 'tipoEstabelecimento': 'Farmácia', "value": "a", "descricao": " venda a retalho de medicamentos essenciais de uso humano e material gastável," },
//     { 'tipoEstabelecimento': 'Farmácia', "value": "b", "descricao": " venda a grosso de medicamentos essenciais de uso humano incluido medicamentos de especialidade e medicamentos contendo substâncias psicotrópicas e estupefacientes sujeitos à legislação especial," },
//     { 'tipoEstabelecimento': 'Farmácia', "value": "c", "descricao": " venda a retalho de equipamento médico, meios de diagnóstico e material hospitalar," },

//     // Distribuidor
//     { 'tipoEstabelecimento': 'Distribuidor', "value": "d", "descricao": " Distribuição de equipamento médico, meios de diagnóstico e material hospitalar," },
//     { 'tipoEstabelecimento': 'Distribuidor', "value": "f", "descricao": " Distribuição de medicamentos essenciais de uso humano, incluido medicamentos de especialidade de medicamentos contendo substâncias psicotrópicas e estupefacientes sujeitos à legislação especial, material gastável e cosméticos," },
//     { 'tipoEstabelecimento': 'Distribuidor', "value": "g", "descricao": " armazenar e distribuir gases medicinais as instituições sanitárias," },

//     // 'Importador e Distribuidor' 
//     { 'tipoEstabelecimento': 'Importador e Distribuidor', "value": "h", "descricao": " Importação e Distribuição de material hospitalar e meios de diagnóstico" },
//     { 'tipoEstabelecimento': 'Importador e Distribuidor', "value": "i", "descricao": " Importação e Distribuição de medicamentos essenciais de uso humano, incluido medicamentos de especialidade e medicamentos contendo substâncias psicotrópicas e estupefacientes sujeitos à legislação especial, material gastável e cosméticos," },

//     // 'Importador'
//     { 'tipoEstabelecimento': 'Importador', "value": "j", "descricao": " Importação de equipamento médico, meios de diagnóstico e material hospitalar," },
//     { 'tipoEstabelecimento': 'Importador', "value": "k", "descricao": " Importação de medicamentos essenciais de uso humano, incluido medicamentos de especialidade de medicamentos contendo substâncias psicotrópicas e estupefacientes sujeitos à legislação especial, material gastável e cosméticos," },

//     // 'Óptica'
//     { 'tipoEstabelecimento': 'Óptica', "value": "l", "descricao": " importação e distribuição de equipamento para oftalmologia e optometria, lentes, lentes oculares e material de diagnóstico optico," },
//     { 'tipoEstabelecimento': 'Óptica', "value": "m", "descricao": " venda a retalho de equipamento para oftalmologia e optometria, lentes, lentes oculares e material de diagnóstico optico," },

//     // 'Loja de Cosméticos'
//     { 'tipoEstabelecimento': 'Loja de Cosméticos', "value": "n", "descricao": " venda a retalho de cosmeticos," },
//     { 'tipoEstabelecimento': 'Loja de Cosméticos', "value": "o", "descricao": " importação e distribuição de produtos cosmeticos," },

//     // 'Ervanária'
//     { 'tipoEstabelecimento': 'Ervanária', "value": "o", "descricao": " venda a retalho de produtos naturais e suplementos de uso humano," },
// ];

export default function AutorizacaoOptions({ options, value, onChange, empresa, tipoEstabelecimento }) {

    // const optionText = AUTORIZACAO;

    return (
        <>
            <RadioGroup name="tipoAutorizacao" value={value} onChange={onChange}>
                {options.map((item, index) => (
                    <Typography key={item._id} m={2}>
                        <FormControlLabel
                            value={item.descricao}
                            control={<Radio />}
                            label={
                                <>
                                    {index + 1} - Autoriza a empresa <b>{empresa}</b> a exercer a
                                    <b>{item.descricao}</b>,
                                </>
                            }
                        />
                    </Typography>
                ))}
            </RadioGroup>

            {options.length < 1 && <LoadingSkteleton/>}
        </>
    );
}
